import LanguageIcon from "@mui/icons-material/Language";
import {
  AppBar,
  Avatar,
  Box,
  FormControl,
  IconButton,
  Menu,
  MenuItem,
  Select,
  Toolbar,
} from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { logoutUser } from "../../../redux/Actions/authActions";
import NotificationMenu from "../../NotificationsMenu/NotificationsMenu";
import LanguageLabel from "../../LanguageToggle/LanguageLabel";

const StudentNavBar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { t, i18n } = useTranslation();

  const isDuringPlacementTest = location.pathname.startsWith("/placement/test");

  const studentId = useSelector((state) => state.auth.user.studentId);
  const profileName = useSelector((state) => state.auth.user?.profileName);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuClose = () => setAnchorEl(null);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const getInitials = (name) => {
    const initials = name.split(" ");
    return initials.length > 1
      ? `${initials[0][0]}${initials[1][0]}`
      : initials[0][0];
  };

  const handleLogout = () => {
    dispatch(logoutUser(false));
    handleMenuClose();
  };
  const handleLanguageChange = (language) => {
    i18n.changeLanguage(language);
  };

  const currentLanguage = i18n.language?.split("-")[0];
  const selectedLanguage = ["ar", "de", "en"].includes(currentLanguage)
    ? currentLanguage
    : "en";
  const isRTL = selectedLanguage === "ar";
  const navBarShift = isRTL
    ? { right: { md: "var(--sidebar-width)", xs: 0 } }
    : { left: { md: "var(--sidebar-width)", xs: 0 } };

  return (
    <>
      <Box
        sx={{
          pointerEvents: isDuringPlacementTest ? "none" : "auto",
          opacity: isDuringPlacementTest ? 0.3 : 1,
        }}
      >
        <AppBar
          position="fixed"
          sx={{
            backgroundColor: "#FFFFFF",
            boxShadow: "none",
            border: "1px solid #D2D6DB",
            zIndex: 1300,
            width: { md: "calc(100% - var(--sidebar-width))", xs: "100%" },
            height: 72,
            ...navBarShift,
            transition: "all 0.3s",
          }}
        >
          <Toolbar
            sx={{ justifyContent: "flex-end", gap: "32px", flexWrap: "wrap" }}
          >
            <Box
              width="100%"
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: 80,
                  mt: "-5px",
                }}
              >
                <Box
                  component={Link}
                  to="/"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Box
                    component="img"
                    src="/al-germanist-logo.png"
                    alt="ALGermanist"
                    sx={{
                      height: 70,
                      width: 92,
                      mr: 1,
                    }}
                  />
                </Box>
              </Box>
              <Box display="flex" alignItems="center" gap={4}>
                <Box display="flex" alignItems="center" gap={1}>
                  <LanguageIcon fontSize="small" color="action" />
                  <FormControl size="small" sx={{ minWidth: 100 }}>
                    <Select
                      value={selectedLanguage}
                      onChange={(e) => handleLanguageChange(e.target.value)}
                      displayEmpty
                      sx={{
                        height: 30,
                        borderRadius: "18px",
                        backgroundColor: "#F6F7F8",
                        fontWeight: 600,
                        color: "#333",
                        px: 1,
                        "& .MuiSelect-select": {
                          py: 0.8,
                          display: "flex",
                          alignItems: "center",
                        },
                      }}
                      renderValue={(val) => <LanguageLabel language={val} />}
                    >
                      <MenuItem value="ar"><LanguageLabel language="ar" full /></MenuItem>
                      <MenuItem value="de"><LanguageLabel language="de" full /></MenuItem>
                      <MenuItem value="en"><LanguageLabel language="en" full /></MenuItem>
                    </Select>
                  </FormControl>
                </Box>

                {/* Notifications */}
                <NotificationMenu studentId={studentId} />

                {/* Profile Dropdown */}
                <IconButton
                  onClick={handleProfileMenuOpen}
                  sx={{ ml: 2, color: "white" }}
                >
                  <Avatar
                    sx={{
                      bgcolor: "#f0ececff",
                      color: "black",
                      padding: 3,
                      width: 40,
                      height: 40,
                      fontWeight: "semi-bold",
                    }}
                  >
                    {getInitials(profileName)}
                  </Avatar>
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleMenuClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                >
                  <MenuItem onClick={() => navigate("/student/profile")}>
                    {t("navbar.profile")}
                  </MenuItem>
                  <MenuItem onClick={handleLogout}>
                    {t("navbar.logout")}
                  </MenuItem>
                </Menu>
              </Box>
            </Box>
          </Toolbar>
        </AppBar>
      </Box>
    </>
  );
};

export default StudentNavBar;
